<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">日程和提醒</a></li>
                <li><a href="#">修改代办</a></li>
            </ul>
        </div>
        <div class="formbody">  
            <div id="usual1" class="usual"> 
  	            <div id="tab1" class="tabson">    
                    <ul class="forminfo">    
                        <li><label>标题</label><input name="" v-model="dbtitle" type="text" class="dfinput"   style="width:518px;"/></li>    
                        <li style="height:300px;"><label>内容</label>
                            <!-- <textarea id="content7" name="content" style="width:700px;height:250px;visibility:hidden;"></textarea> -->
                            <editor-bar style="width:700px;height:250px;margin:0px 5px 15px 85px;" v-model="editor.info" :isClear="isClear" @change="change"></editor-bar>
                        </li>
                        <li><label>优先级</label>  
                            <div class="vocation">
                                <el-select v-model="prority" placeholder="请选择">
                                    <el-option label="最高" value="5"></el-option>
                                    <el-option label="高" value="4"></el-option>
                                    <el-option label="普通" value="3"></el-option>
                                    <el-option label="低" value="2"></el-option>
                                    <el-option label="最低" value="1"></el-option>
                                </el-select>
                            </div>
                        </li>    
                        <li><label>完成进度</label>    
                            <div class="vocation">
                                <el-select v-model="degree" placeholder="请选择">
                                    <el-option
                                        v-for="item in degreeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                
                                </el-select>
                            </div>    
                        </li>    
                        <li><label>完成期限</label>    
                            <div class="cityleft">
                                <el-date-picker v-model="endtime"  type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="完成期限" />
                            </div>
                        </li>    
                        <li><label>提醒设置</label>    
                            <div class="vocation">
                            <i id="settx" class="lh33" @click="openTiXing()">开启提醒</i><br/>
                            <i id="settxok" class="lh33" style="display:none;">提醒已设置 <br/><ol id="settxmethoddesc">{{txmethoddesc}} </ol>&nbsp;&nbsp;<a href="#" style="color:lightcoral;" @click="edittx()">编辑</a>&nbsp;&nbsp;<a href="#" style="color:lightcoral;" @click="deletetx()">取消提醒</a></i>
                            </div>
                        </li>  
                        <li><label>&nbsp;</label><input name="" @click="saveDaiBan()" type="button" class="btn" value="马上发布"/></li>
                    </ul>    
                </div>
	        </div> 
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
import EditorBar from '@/components/EditorBar'
var eb = EditorBar;
export default {
    components : {
        'v-cookie' : cookie,
        EditorBar,
    },
    data(){
        return{
            id:this.$route.query.id,
            dbtitle:'',
            prority:'3',
            degree:0,
            degreeList:[

            ],
            endtime:'',
            sid:'',
            editor: {
                info: ''
            },
            isClear: false,
            txId:0,
            txmethoddesc:'',
            md:'111',
        }
    },
    mounted(){
        this.setDegreeList();
        this.getDaiBanDetail();
    },
    methods:{
        setDegreeList(){
            for(var i = 0; i<=100;i++)
            {
                this.degreeList.push({label:i,value:i});
            }
        },
        change (val) {
            this.editor.info1 = val;
        },
        openTiXing(){
            window.open('/memorandumaddtx?sid='+this.sid,"newwindow", "height=400, width=600,top=162,left=389, toolbar =no, menubar=no, scrollbars=no, resizable=no, location=no, status=no");
        },
        getDaiBanDetail(){
            let that = this;
            let data = {'id':this.id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/kingtime/getdaibandetail.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.dbtitle = res.data.daiban.dbtitle;
                    that.sid = res.data.daiban.sid;
                    eb.methods.setContent(res.data.daiban.dbcontent);
                    that.prority = res.data.daiban.prority;
                    that.degree = res.data.daiban.degree;
                    that.endtime = res.data.daiban.endtime;
                    that.editor.info = res.data.daiban.dbcontent;
                    if(0 == res.data.txId){
                        document.getElementById("settx").style.display = "block";
                        document.getElementById("settxok").style.display = "none";
                    }
                    else{
                        that.txId = res.data.txId;
                        document.getElementById("settx").style.display = "none";
                        document.getElementById("settxok").style.display = "block";
                    }
                    that.txmethoddesc = res.data.txmethoddesc;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        saveDaiBan(){
            if(this.dbtitle.trim() == ''){
                alert("代办标题不能为空！");
                return;
            }
            if(this.editor.info.trim() == '' || this.editor.info.trim() == '<p><br></p>'){
                alert("代办内容不能为空！");
                return;
            }
            if(this.endtime.trim() == ''){
                alert("完成期限不能为空！");
                return;
            }
            var that = this;
            let data = {'id':this.id,'dbtitle':this.dbtitle,'dbcontent':this.editor.info,'prority':this.prority,'degree':this.degree,'endtime':this.endtime,'sid':this.sid,'status':0}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/kingtime/upddaiban.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("修改代办成功！");
                    // that.$router.push('/memorandum')
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        edittx(){
            window.open('/memorandumtxedit?id='+this.txId,"newwindow", "height=400, width=800,top=162,left=389, toolbar =no, menubar=no, scrollbars=no, resizable=no, location=no, status=no");
        },
        setok(){
            alert('setok');
        },
        deletetx(){
            var that = this;
            let data = {'ids':this.txId}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/kingtime/compdeltixing.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    document.getElementById("settx").style.display = "block";
                    document.getElementById("settxok").style.display = "none";
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/kingtime/memorandumedit.vue